import repository from './repository';

const STATUS_COLOR_MAP = {
    1: 'txt-brown',
    2: 'txt-green',
    3: 'txt-black',
    4: 'txt-purple',
    5: 'txt-red'
};

const createDataInit = () => ({
    company_cd: '',
    company_name: '',
    md_cd: '',
    application_no: '',
    typeNo: '',
    application_date: '',
    start_date: '',
    end_date: '',
    start_time: '',
    end_time: '',
    time_in: '',
    time_out: '',
    target_no: '',
    reasonClass: '',
    reason: '',
    content: '',
    detailClass: '',
    ShinseiDetail: '',
    money: '',
    detail: '',
    target_month: '',
    filename: '',
    file_path: '',
    file: null,
    file_list: createEmptyFileList(),
    status: '',
    status_color: STATUS_COLOR_MAP[1],
    status_code: 1
});

export default {
    namespaced: true,
    state: {
        data: { ...createDataInit() },
        searchData: [],
        options: {
            types: [],
            statuses: []
        }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...createDataInit() };
            state.searchData = [];
        },
        setData(state, data) {
            state.data = {
                ...state.data,
                ...(data || {})
            };
        },
        setSearchData(state, data) {
            state.searchData = data ?? [];
        },
        setTypes(state, data) {
            state.options.types = data ?? [];
        },
        setStatuses(state, data) {
            state.options.statuses = data ?? [];
        }
    },
    actions: {
        getData(context, input) {
            return repository
                .getData(input.body)
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const detail = data?.Data?.detail ?? {};
                        const statusCode = Number(pick(detail, ['status_code', 'status', 'Status']) || 1);
                        const arrivalTime = formatTime(pick(detail, ['arrival_time', 'ArrivalTime', 'start_time', 'StartTime']));
                        const departureTime = formatTime(pick(detail, ['departure_time', 'DepartureTime', 'departureTime', 'end_time', 'EndTime']));
                        context.commit('setData', {
                            ...detail,
                            company_cd: detail.company_cd ?? '',
                            company_name: detail.company_name ?? '',
                            application_no: pick(detail, ['application_no', 'shinsei_no', 'ShinseiNo']),
                            typeNo: pick(detail, ['typeNo', 'type', 'Type']),
                            application_date: formatDate(pick(detail, ['application_date', 'ApplicationDate'])),
                            start_date: formatDate(pick(detail, ['start_date', 'StartDate'])),
                            end_date: formatDate(pick(detail, ['end_date', 'EndDate'])),
                            time_in: arrivalTime,
                            time_out: departureTime,
                            start_time: arrivalTime,
                            end_time: departureTime,
                            target_no: pick(detail, ['target_no', 'TargetNo']),
                            reasonClass: pick(detail, ['reason_class', 'ReasonClass']),
                            reason: pick(detail, ['reason', 'Reason']),
                            content: pick(detail, ['content', 'Content']),
                            detailClass: pick(detail, ['detail_class', 'DetailClass', 'detailClass']),
                            ShinseiDetail: pick(detail, ['shinsei_detail', 'ShinseiDetail']),
                            money: pick(detail, ['amount', 'Amount']),
                            detail: pick(detail, ['detail', 'Detail', 'detail_input', 'DetailInput']),
                            target_month:
                                formatMonth(pick(detail, ['target_month', 'TargetMonth']), pick(detail, ['application_date', 'ApplicationDate'])) ||
                                (hasAnyDayFlag(detail) ? extractYearMonth(pick(detail, ['application_date', 'ApplicationDate'])) : ''),
                            ...pickDayFlags(detail),
                            file_path: detail.attachment01 ?? '',
                            filename: extractFileName(detail.attachment01 ?? ''),
                            file_list: buildFileList(detail),
                            status_code: statusCode,
                            status: pick(detail, ['status_name', 'statusName']) || '',
                            status_color: STATUS_COLOR_MAP[statusCode] ?? ''
                        });
                        context.commit('setSearchData', data?.Data?.approval_logs ?? []);
                        if (input.callback) input.callback(data);
                    } else if (input.onError) {
                        input.onError(data.Message || data.Data?.message || 'Get data failed.');
                    }
                })
                .catch((e) => {
                    if (input.onError) input.onError(e.message);
                });
        },
        storeSave(context, input) {
            return repository
                .storeSave(input.body)
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) input.callback(data);
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message);
                        } else if (input.onError) {
                            input.onError(Array.isArray(data.Message) ? data.Message.join('\n') : data.Message);
                        }
                    } else if (input.onError) {
                        input.onError(data.Message || data.Data?.message || 'Save failed.');
                    }
                })
                .catch((e) => {
                    if (input.onError) input.onError(e.message);
                });
        },
        storeCancel(context, input) {
            return repository
                .storeCancel(input.body)
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) input.callback(data);
                    } else if (input.onError) {
                        input.onError(data.Message || data.Data?.message || 'Cancel failed.');
                    }
                })
                .catch((e) => {
                    if (input.onError) input.onError(e.message);
                });
        }
    }
};

function formatDate(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return `${value}`.substring(0, 10);
    const y = date.getFullYear();
    const m = `${date.getMonth() + 1}`.padStart(2, '0');
    const d = `${date.getDate()}`.padStart(2, '0');
    return `${y}/${m}/${d}`;
}

function formatTime(value) {
    if (value === null || value === undefined || value === '' || `${value}` === '0') return '';
    const raw = `${value}`.replace(':', '');
    const padded = raw.padStart(4, '0');
    return `${padded.slice(0, 2)}:${padded.slice(2, 4)}`;
}

function formatMonth(value, baseDateValue = '') {
    if (!value || `${value}` === '0') return '';
    const raw = `${value}`.replace(/\D/g, '');
    if (raw.length >= 6) return `${raw.slice(0, 4)}/${raw.slice(4, 6)}`;
    if (raw.length <= 2) {
        const month = Number(raw);
        if (month >= 1 && month <= 12) {
            const year = resolveYear(baseDateValue);
            return `${year}/${String(month).padStart(2, '0')}`;
        }
    }
    return '';
}

function extractFileName(path) {
    if (!path) return '';
    const parts = `${path}`.split(/[\\/]+/);
    return parts[parts.length - 1] ?? '';
}

function createEmptyFileItem(path = '') {
    return {
        name: extractFileName(path),
        path,
        old_path: path,
        file: null
    };
}

function createEmptyFileList() {
    return [createEmptyFileItem()];
}

function buildFileList(detail) {
    const list = Array.from({ length: 5 }, (_, index) => {
        const path = detail?.[`attachment0${index + 1}`] ?? detail?.[`Attachment0${index + 1}`] ?? '';
        return createEmptyFileItem(path);
    }).filter((item) => item.path);

    if (list.length < 5) {
        list.push(createEmptyFileItem());
    }

    return list.length > 0 ? list : createEmptyFileList();
}

function extractYearMonth(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const y = date.getFullYear();
    const m = `${date.getMonth() + 1}`.padStart(2, '0');
    return `${y}/${m}`;
}

function resolveYear(value) {
    const date = value ? new Date(value) : new Date();
    if (Number.isNaN(date.getTime())) return new Date().getFullYear();
    return date.getFullYear();
}

function pick(data, keys) {
    for (const key of keys) {
        if (data?.[key] !== undefined && data?.[key] !== null && data?.[key] !== '') {
            return data[key];
        }
    }
    return '';
}

function pickDayFlags(data) {
    const result = {};
    for (let day = 1; day <= 31; day++) {
        const keyLower = `d${day}`;
        const keyUpper = `D${day}`;
        result[keyLower] = Number(data?.[keyLower] ?? data?.[keyUpper] ?? 0) || 0;
    }
    return result;
}

function hasAnyDayFlag(data) {
    for (let day = 1; day <= 31; day++) {
        if (Number(data?.[`d${day}`] ?? data?.[`D${day}`] ?? 0) > 0) {
            return true;
        }
    }
    return false;
}
